import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '../../Button';
import { useForm } from '../../Form';
import Form from '../../Form/Form';
import Field from '../../Field';
import memoryService from '../../../services/memoryService';
import Toast from '../../Toast';

const StyledUpdateMemoryModal = styled(Form)`
  width: 100%;
  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;

const UpdateMemoryModal = ({ onClose, data, refetch }) => {
  const [form] = useForm();
  const [loading, setLoading] = useState(false);

  const handleMemoryUpdate = async e => {
    const payload = {
      memory_id: data?.id,
      text: e?.memory,
    };

    try {
      setLoading(true);
      const resp = await memoryService.updateMemory(payload);
      if (resp?.success) {
        Toast({
          type: 'success',
          message: 'Memory Updated Successfully',
        });
        setLoading(false);
        onClose();
        refetch();
      } else {
      }
    } catch (error) {
      Toast({
        type: 'error',
        message: error?.detail || 'Something went wrong!!!',
      });
      setLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        memory: data?.memory,
      });
    }
  }, [data]);

  return (
    <StyledUpdateMemoryModal form={form} onSubmit={handleMemoryUpdate}>
      <Form.Item
        label="Memory"
        type="text"
        name="memory"
        rounded
        placeholder="Enter your memory title"
        rules={[{ required: true, message: 'memory is required' }]}>
        <Field />
      </Form.Item>

      <div className="btn-holder">
        <Button width="102px" type="button" variant="secondary-outline" onClick={() => onClose()}>
          Cancel
        </Button>
        <Button width="108px" loader={loading}>
          Update
        </Button>
      </div>
    </StyledUpdateMemoryModal>
  );
};

export default UpdateMemoryModal;
